// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2VyeZ","alert":"SettungsInbox_alert__maF0S"};